import { EquipmentAsset } from '../../core/models';

const getAssetLocation = (asset: EquipmentAsset) => {
  let location = '';
  if (asset.branch_city) {
    location = asset.branch_city;
  }
  if (asset.branch_state) {
    location += location.length > 0 ? ', ' : '';
    location += asset.branch_state;
  }
  if (asset.branch_name || asset.branch) {
    location += location.length > 0 ? ' - ' : '';
    location += asset.branch_name || asset.branch;
  }
  return location;
};

const getConditionalLabel = (
  value: unknown,
  config: {
    test?: (value: unknown) => boolean;
    label: string | ((value?: string | number) => string);
  }[],
  defaultLabel: string | ((value?: string | number) => string)
): string => {
  const renderLabel = (factoryOrString: any) => {
    if (typeof factoryOrString === 'string') {
      return factoryOrString;
    } else {
      return factoryOrString(value);
    }
  };

  const iter = config.values();
  let result = '';
  for (const conf of iter) {
    if (conf.test && conf.test(value)) {
      result = renderLabel(conf.label);
      break;
    }
  }

  if (!result && defaultLabel) {
    result = renderLabel(defaultLabel);
  }

  return result;
};

export default {
  getAssetLocation,
  getConditionalLabel,
};
